(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-input')) {
    customElements.define(
      'quantity-input',
      class QuantityInput extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('.quantity__input');
          this.addEventListener('click', this.onButtonClick.bind(this));
          this.input.addEventListener('change', this.updateButtons.bind(this));
          this.updateButtons();
        }

        onButtonClick(event) {
          const button = event.target.closest('[data-quantity-change]');
          if (!button) return;

          const previousValue = this.input.value;
          if (button.dataset.quantityChange === '1') {
            this.input.stepUp();
          } else {
            this.input.stepDown();
          }

          if (previousValue !== this.input.value) {
            this.input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        updateButtons() {
          const value = Number(this.input.value);
          const minimum = Number(this.input.min);
          const maximum = this.input.max === '' ? null : Number(this.input.max);
          this.querySelector('[data-quantity-change="-1"]').disabled = value <= minimum;
          this.querySelector('[data-quantity-change="1"]').disabled = maximum !== null && value >= maximum;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
